import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { SplideSlider } from '../modules/splide';
import { wrapAll } from '../utils/wrappers';

export function initSlider() {
    const columnGap = 'Min(2.26vw, 1.18em)';
    const smallerColumnGap = 'Min(6.66vw, 1.64em)';

    // Elemente wrappen wenn der ganze Artikel ein Slider ist ----------------------------------------------------------

    // document.querySelectorAll('.mod_article.slider .mod_newslist .content_inside .splide').forEach((slider) => {
    //     wrapAll(slider.childNodes, '<div class="slider_inside">');
    // });

    document.querySelectorAll('.mod_article.carousel .content-wrapper').forEach((slider) => {
        wrapAll(slider.childNodes, '<div class="carousel_inside">');
    });

    // Slider- & Karusselstile -----------------------------------------------------------------------------------------

    // Standard Slider (Artikel + Galerie) z.B. Fakten Fade-Slider
    // document.querySelectorAll('.slider_inside, .ce_gallery.slider ul').forEach((slider) => {
    //     const splide = new SplideSlider(slider, {
    //         type: 'fade',
    //         rewind: true,
    //         easing: 'ease',
    //         arrows: true,
    //         pagination: false,
    //         speed: 500,
    //         autoplay: false,
    //         interval: 5000,
    //         pauseOnHover: false,
    //         breakpoints: {
    //             768: {
    //                 arrows: false,
    //                 pagination: true,
    //             },
    //         },
    //     });

    //     if (slider.closest('.autoplay')) {
    //         splide.enableAutoPlay();
    //     }

    //     if (slider.closest('.disable-pagination')) {
    //         splide.disablePagination();
    //     }

    //     splide.mount();
    // });

    // Kundenlogos Agenturseite
    // document.querySelectorAll('#customer-logos').forEach((slider) => {
    //     const splide = new SplideSlider(slider, {
    //         label: 'Kundenlogos',
    //         type: 'fade',
    //         rewind: true,
    //         easing: 'ease',
    //         arrows: false,
    //         pagination: true,
    //         speed: 500,
    //         autoplay: false,
    //         interval: 5000,
    //         pauseOnHover: false,
    //         mediaQuery: 'min',
    //         breakpoints: {
    //             576: {
    //                 destroy: true,
    //                 pagination: false,
    //             },
    //         },
    //     });

    //     if (slider.classList.contains('autoplay')) {
    //         splide.enableAutoPlay();
    //     }

    //     if (slider.classList.contains('disable-pagination')) {
    //         splide.disablePagination();
    //     }

    //     splide.mount();
    // });

    // Kundenlogos Laufband Startseite
    // document.querySelectorAll('.ce_gallery.logo-ticker ul').forEach((slider) => {
    //     new SplideSlider(slider, {
    //         type: 'loop',
    //         label: 'Kundenlogos',
    //         drag: false,
    //         arrows: false,
    //         pagination: false,
    //         autoWidth: true,
    //         gap: '8vw',
    //         autoScroll: {
    //             pauseOnHover: false,
    //             speed: 0.8,
    //         },
    //         breakpoints: {
    //             768: {
    //                 autoScroll: { speed: 0.5 },
    //             },
    //         },
    //     }).mount({ AutoScroll });
    // });

    // Kundenstimmen
    // document.querySelectorAll('.carousel_inside, .ce_gallery.carousel ul').forEach((slider) => {
    //     new SplideSlider(slider, {
    //         type: 'loop',
    //         perPage: 3,
    //         perMove: 1,
    //         easing: 'ease',
    //         speed: 1000,
    //         pagination: false,
    //         gap: smallerColumnGap,
    //         breakpoints: {
    //             1400: {
    //                 perPage: 2,
    //             },
    //             576: {
    //                 perPage: 1,
    //                 pagination: true,
    //                 arrows: false,
    //             },
    //         },
    //     }).mount();
    // });

    // Projekte-Karussell
    document.querySelectorAll('.mod_newslist > .content_inside .splide .splide__list').forEach((slider) => {
        const splide = new SplideSlider(slider, {
            type: 'loop',
            label: 'Referenzen',
            perPage: 3,
            perMove: 1,
            pagination: false,
            gap: columnGap,
            lazyLoad: true,
            arrows: true,
            easing: 'ease',
            speed: 500,
            drag: 'free',
            autoScroll: {
                speed: 0.5,
                pauseOnHover: true,
                pauseOnFocus: false,
            },
            breakpoints: {
                1199: {
                    perPage: 2,
                },
                767: {
                    perPage: 1.5,
                    autoScroll: { speed: 0.5 },
                    arrows: false,
                },
                499: {
                    perPage: 1,
                },
            },
        }).mount({ AutoScroll });

        let timer;

        // Pause scroll for 6 seconds after dragging and moving
        splide.on('dragged moved', () => {
            splide.Components.AutoScroll.pause();

            clearTimeout(timer);

            timer = setTimeout(() => splide.Components.AutoScroll.play(), 6000);
        });
    });

    // Categories Caroussel
    document.querySelectorAll('#categories.splide .splide__list').forEach((slider) => {
        const splide = new SplideSlider(slider, {
            type: 'loop',
            label: 'Referenzen',
            perPage: 4,
            perMove: 1,
            arrows: true,
            pagination: false,
            lazyLoad: true,
            gap: columnGap,
            easing: 'ease',
            // direction: 'rtl',
            speed: 500,
            drag: 'free',
            autoScroll: {
                speed: 0.5,
                pauseOnHover: true,
                pauseOnFocus: false,
            },
            breakpoints: {
                1199: {
                    perPage: 2,
                },
                767: {
                    perPage: 1.5,
                    autoScroll: { speed: 0.5 },
                    arrows: false,
                },
                499: {
                    perPage: 1,
                },
            },
        }).mount({ AutoScroll });

        let timer;

        // Pause scroll for 6 seconds after dragging and moving
        splide.on('dragged moved', () => {
            splide.Components.AutoScroll.pause();

            clearTimeout(timer);

            timer = setTimeout(() => splide.Components.AutoScroll.play(), 6000);
        });
    });

    // Instagram-Karussell
    // document.querySelectorAll('.insta-feed-ticker_inside').forEach((slider) => {
    //     const splide = new SplideSlider(slider, {
    //         type: 'loop',
    //         perPage: 4,
    //         perMove: 1,
    //         pagination: false,
    //         gap: columnGap,
    //         easing: 'ease',
    //         speed: 500,
    //         drag: 'free',
    //         autoScroll: {
    //             speed: 0.5,
    //             pauseOnHover: false,
    //             pauseOnFocus: false,
    //         },
    //         breakpoints: {
    //             1920: {
    //                 perPage: 3,
    //             },
    //             1199: {
    //                 perPage: 2,
    //             },
    //             767: {
    //                 perPage: 1.5,
    //                 autoScroll: { speed: 0.5 },
    //                 arrows: false,
    //             },
    //             /* 499: {
    //                 perPage: 1,
    //             }, */
    //         },
    //     }).mount({ AutoScroll });

    //     let timer;

    //     // Pause scroll for 20 seconds after dragging and moving
    //     splide.on('dragged moved', () => {
    //         splide.Components.AutoScroll.pause();

    //         clearTimeout(timer);

    //         timer = setTimeout(() => splide.Components.AutoScroll.play(), 20000);
    //     });
    // });

    // "Durchrollende" Wörte Startseite Einleitung
    // document.querySelectorAll('.word-flip ul').forEach((slider) => {
    //     new SplideSlider(slider, {
    //         type: 'loop',
    //         direction: 'ttb',
    //         speed: 500,
    //         autoplay: true,
    //         height: '1.2em',
    //         easing: 'ease',
    //         interval: 2000,
    //         arrows: false,
    //         pagination: false,
    //         pauseOnHover: false,
    //         updateOnMove: true,
    //     }).mount();
    // });
}
